"use client";

import * as React from "react";
import styled from "styled-components";

const StyledInput = styled.input`
  display: flex;
  height: 40px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background-color: var(--color-bg-surface);
  padding: 8px 12px;
  font-size: 14px;
  transition: all 0.15s ease;

  &::file-selector-button {
    border: none;
    background: transparent;
    font-size: 14px;
    font-weight: 500;
  }

  &::placeholder {
    color: var(--color-text-tertiary);
  }

  &:focus-visible {
    outline: none;
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: var(--color-bg-page);
  }

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  (props, ref) => {
    return <StyledInput ref={ref} {...props} />;
  }
);
Input.displayName = "Input";

export { Input };
